module.exports = __webpack_public_path__ + "img/illustration2.bf23d8a4.svg";